package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.VoidPluralString
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String
import kotlin.collections.Map

public object ResStrings {
  private val baseLocale: StringsEn = StringsEn

  private val locales: Map<String, Strings> = mapOf("pl" to StringsPl, "en" to StringsEn)

  public val locale: String
    get() = locales[getCurrentLanguageCode()]?.locale ?: baseLocale.locale

  public val app_name: String
    get() = locales[getCurrentLanguageCode()]?.app_name ?: baseLocale.app_name

  public val home_screen: String
    get() = locales[getCurrentLanguageCode()]?.home_screen ?: baseLocale.home_screen

  public val education_screen: String
    get() = locales[getCurrentLanguageCode()]?.education_screen ?: baseLocale.education_screen

  public val skills_screen: String
    get() = locales[getCurrentLanguageCode()]?.skills_screen ?: baseLocale.skills_screen

  public val experience_screen: String
    get() = locales[getCurrentLanguageCode()]?.experience_screen ?: baseLocale.experience_screen

  public val projects_screen: String
    get() = locales[getCurrentLanguageCode()]?.projects_screen ?: baseLocale.projects_screen

  public val project_details_screen: String
    get() = locales[getCurrentLanguageCode()]?.project_details_screen ?: baseLocale.project_details_screen

  public val social_media_screen: String
    get() = locales[getCurrentLanguageCode()]?.social_media_screen ?: baseLocale.social_media_screen

  public val achievements_screen: String
    get() = locales[getCurrentLanguageCode()]?.achievements_screen ?: baseLocale.achievements_screen

  public val homepage_description: String
    get() = locales[getCurrentLanguageCode()]?.homepage_description ?: baseLocale.homepage_description

  public val homepage_tutor_website: String
    get() = locales[getCurrentLanguageCode()]?.homepage_tutor_website ?: baseLocale.homepage_tutor_website

  public val main: String
    get() = locales[getCurrentLanguageCode()]?.main ?: baseLocale.main

  public val skills: String
    get() = locales[getCurrentLanguageCode()]?.skills ?: baseLocale.skills

  public val projects: String
    get() = locales[getCurrentLanguageCode()]?.projects ?: baseLocale.projects

  public val experience: String
    get() = locales[getCurrentLanguageCode()]?.experience ?: baseLocale.experience

  public val education: String
    get() = locales[getCurrentLanguageCode()]?.education ?: baseLocale.education

  public val social_media: String
    get() = locales[getCurrentLanguageCode()]?.social_media ?: baseLocale.social_media

  public val achievements: String
    get() = locales[getCurrentLanguageCode()]?.achievements ?: baseLocale.achievements

  public val resume: String
    get() = locales[getCurrentLanguageCode()]?.resume ?: baseLocale.resume

  public val no_results: String
    get() = locales[getCurrentLanguageCode()]?.no_results ?: baseLocale.no_results

  public val search_placeholder: String
    get() = locales[getCurrentLanguageCode()]?.search_placeholder ?: baseLocale.search_placeholder

  public val search: String
    get() = locales[getCurrentLanguageCode()]?.search ?: baseLocale.search

  public val home_description: String
    get() = locales[getCurrentLanguageCode()]?.home_description ?: baseLocale.home_description

  public val skills_description: String
    get() = locales[getCurrentLanguageCode()]?.skills_description ?: baseLocale.skills_description

  public val projects_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_description ?: baseLocale.projects_description

  public val experience_description: String
    get() = locales[getCurrentLanguageCode()]?.experience_description ?: baseLocale.experience_description

  public val education_description: String
    get() = locales[getCurrentLanguageCode()]?.education_description ?: baseLocale.education_description

  public val social_media_description: String
    get() = locales[getCurrentLanguageCode()]?.social_media_description ?: baseLocale.social_media_description

  public val achievements_description: String
    get() = locales[getCurrentLanguageCode()]?.achievements_description ?: baseLocale.achievements_description

  public val skills_button: String
    get() = locales[getCurrentLanguageCode()]?.skills_button ?: baseLocale.skills_button

  public val projects_button: String
    get() = locales[getCurrentLanguageCode()]?.projects_button ?: baseLocale.projects_button

  public val experience_button: String
    get() = locales[getCurrentLanguageCode()]?.experience_button ?: baseLocale.experience_button

  public val education_button: String
    get() = locales[getCurrentLanguageCode()]?.education_button ?: baseLocale.education_button

  public val social_media_button: String
    get() = locales[getCurrentLanguageCode()]?.social_media_button ?: baseLocale.social_media_button

  public val achievements_button: String
    get() = locales[getCurrentLanguageCode()]?.achievements_button ?: baseLocale.achievements_button

  public val view_more: String
    get() = locales[getCurrentLanguageCode()]?.view_more ?: baseLocale.view_more

  public val stack_title: String
    get() = locales[getCurrentLanguageCode()]?.stack_title ?: baseLocale.stack_title

  public val hero_label: String
    get() = locales[getCurrentLanguageCode()]?.hero_label ?: baseLocale.hero_label

  public val hero_title_name: String
    get() = locales[getCurrentLanguageCode()]?.hero_title_name ?: baseLocale.hero_title_name

  public val story_label: String
    get() = locales[getCurrentLanguageCode()]?.story_label ?: baseLocale.story_label

  public val story_intro: String
    get() = locales[getCurrentLanguageCode()]?.story_intro ?: baseLocale.story_intro

  public val focus_title: String
    get() = locales[getCurrentLanguageCode()]?.focus_title ?: baseLocale.focus_title

  public val focus_coroutines: String
    get() = locales[getCurrentLanguageCode()]?.focus_coroutines ?: baseLocale.focus_coroutines

  public val focus_coroutines_link_label: String
    get() = locales[getCurrentLanguageCode()]?.focus_coroutines_link_label ?: baseLocale.focus_coroutines_link_label

  public val beyond_title: String
    get() = locales[getCurrentLanguageCode()]?.beyond_title ?: baseLocale.beyond_title

  public val beyond_tutoring: String
    get() = locales[getCurrentLanguageCode()]?.beyond_tutoring ?: baseLocale.beyond_tutoring

  public val learning_title: String
    get() = locales[getCurrentLanguageCode()]?.learning_title ?: baseLocale.learning_title

  public val learning_book: String
    get() = locales[getCurrentLanguageCode()]?.learning_book ?: baseLocale.learning_book

  public val learning_channels: String
    get() = locales[getCurrentLanguageCode()]?.learning_channels ?: baseLocale.learning_channels

  public val skills_title: String
    get() = locales[getCurrentLanguageCode()]?.skills_title ?: baseLocale.skills_title

  public val skills_subtitle: String
    get() = locales[getCurrentLanguageCode()]?.skills_subtitle ?: baseLocale.skills_subtitle

  public val programming_languages: String
    get() = locales[getCurrentLanguageCode()]?.programming_languages ?: baseLocale.programming_languages

  public val frameworks: String
    get() = locales[getCurrentLanguageCode()]?.frameworks ?: baseLocale.frameworks

  public val markup_style: String
    get() = locales[getCurrentLanguageCode()]?.markup_style ?: baseLocale.markup_style

  public val libraries: String
    get() = locales[getCurrentLanguageCode()]?.libraries ?: baseLocale.libraries

  public val languages: String
    get() = locales[getCurrentLanguageCode()]?.languages ?: baseLocale.languages

  public val beginner: String
    get() = locales[getCurrentLanguageCode()]?.beginner ?: baseLocale.beginner

  public val competent: String
    get() = locales[getCurrentLanguageCode()]?.competent ?: baseLocale.competent

  public val proficient: String
    get() = locales[getCurrentLanguageCode()]?.proficient ?: baseLocale.proficient

  public val advanced: String
    get() = locales[getCurrentLanguageCode()]?.advanced ?: baseLocale.advanced

  public val expert: String
    get() = locales[getCurrentLanguageCode()]?.expert ?: baseLocale.expert

  public val native: String
    get() = locales[getCurrentLanguageCode()]?.native ?: baseLocale.native

  public val c1: String
    get() = locales[getCurrentLanguageCode()]?.c1 ?: baseLocale.c1

  public val projects_title: String
    get() = locales[getCurrentLanguageCode()]?.projects_title ?: baseLocale.projects_title

  public val projects_subtitle: String
    get() = locales[getCurrentLanguageCode()]?.projects_subtitle ?: baseLocale.projects_subtitle

  public val mobile_application: String
    get() = locales[getCurrentLanguageCode()]?.mobile_application ?: baseLocale.mobile_application

  public val web_application: String
    get() = locales[getCurrentLanguageCode()]?.web_application ?: baseLocale.web_application

  public val desktop_application: String
    get() = locales[getCurrentLanguageCode()]?.desktop_application ?: baseLocale.desktop_application

  public val multiplatform_application: String
    get() = locales[getCurrentLanguageCode()]?.multiplatform_application ?: baseLocale.multiplatform_application

  public val library: String
    get() = locales[getCurrentLanguageCode()]?.library ?: baseLocale.library

  public val console_application: String
    get() = locales[getCurrentLanguageCode()]?.console_application ?: baseLocale.console_application

  public val game: String
    get() = locales[getCurrentLanguageCode()]?.game ?: baseLocale.game

  public val other: String
    get() = locales[getCurrentLanguageCode()]?.other ?: baseLocale.other

  public val commercial_project: String
    get() = locales[getCurrentLanguageCode()]?.commercial_project ?: baseLocale.commercial_project

  public val academic_project: String
    get() = locales[getCurrentLanguageCode()]?.academic_project ?: baseLocale.academic_project

  public val tools_project: String
    get() = locales[getCurrentLanguageCode()]?.tools_project ?: baseLocale.tools_project

  public val practice_project: String
    get() = locales[getCurrentLanguageCode()]?.practice_project ?: baseLocale.practice_project

  public val personal_project: String
    get() = locales[getCurrentLanguageCode()]?.personal_project ?: baseLocale.personal_project

  public val project_overview: String
    get() = locales[getCurrentLanguageCode()]?.project_overview ?: baseLocale.project_overview

  public val technical_overview: String
    get() = locales[getCurrentLanguageCode()]?.technical_overview ?: baseLocale.technical_overview

  public val release_year: String
    get() = locales[getCurrentLanguageCode()]?.release_year ?: baseLocale.release_year

  public val tech_stack: String
    get() = locales[getCurrentLanguageCode()]?.tech_stack ?: baseLocale.tech_stack

  public val technical_description_placeholder: String
    get() = locales[getCurrentLanguageCode()]?.technical_description_placeholder ?: baseLocale.technical_description_placeholder

  public val screenshots: String
    get() = locales[getCurrentLanguageCode()]?.screenshots ?: baseLocale.screenshots

  public val projects_master_system_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_master_system_shortDescription ?: baseLocale.projects_master_system_shortDescription

  public val projects_master_system_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_master_system_description ?: baseLocale.projects_master_system_description

  public val projects_master_system_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_master_system_technicalDescription ?: baseLocale.projects_master_system_technicalDescription

  public val projects_asertiv_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_asertiv_shortDescription ?: baseLocale.projects_asertiv_shortDescription

  public val projects_asertiv_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_asertiv_description ?: baseLocale.projects_asertiv_description

  public val projects_asertiv_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_asertiv_technicalDescription ?: baseLocale.projects_asertiv_technicalDescription

  public val projects_vl_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_vl_shortDescription ?: baseLocale.projects_vl_shortDescription

  public val projects_vl_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_vl_description ?: baseLocale.projects_vl_description

  public val projects_vl_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_vl_technicalDescription ?: baseLocale.projects_vl_technicalDescription

  public val projects_demiurg_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_demiurg_shortDescription ?: baseLocale.projects_demiurg_shortDescription

  public val projects_demiurg_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_demiurg_description ?: baseLocale.projects_demiurg_description

  public val projects_demiurg_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_demiurg_technicalDescription ?: baseLocale.projects_demiurg_technicalDescription

  public val projects_daymath_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_daymath_shortDescription ?: baseLocale.projects_daymath_shortDescription

  public val projects_daymath_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_daymath_description ?: baseLocale.projects_daymath_description

  public val projects_daymath_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_daymath_technicalDescription ?: baseLocale.projects_daymath_technicalDescription

  public val projects_movie_ai_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_movie_ai_shortDescription ?: baseLocale.projects_movie_ai_shortDescription

  public val projects_movie_ai_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_movie_ai_description ?: baseLocale.projects_movie_ai_description

  public val projects_movie_ai_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_movie_ai_technicalDescription ?: baseLocale.projects_movie_ai_technicalDescription

  public val projects_generator_tabliczek_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_generator_tabliczek_shortDescription ?: baseLocale.projects_generator_tabliczek_shortDescription

  public val projects_generator_tabliczek_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_generator_tabliczek_description ?: baseLocale.projects_generator_tabliczek_description

  public val projects_generator_tabliczek_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_generator_tabliczek_technicalDescription ?: baseLocale.projects_generator_tabliczek_technicalDescription

  public val projects_scheduler_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_scheduler_shortDescription ?: baseLocale.projects_scheduler_shortDescription

  public val projects_scheduler_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_scheduler_description ?: baseLocale.projects_scheduler_description

  public val projects_scheduler_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_scheduler_technicalDescription ?: baseLocale.projects_scheduler_technicalDescription

  public val projects_binary_clock_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_binary_clock_shortDescription ?: baseLocale.projects_binary_clock_shortDescription

  public val projects_binary_clock_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_binary_clock_description ?: baseLocale.projects_binary_clock_description

  public val projects_subtitles_shifter_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_subtitles_shifter_shortDescription ?: baseLocale.projects_subtitles_shifter_shortDescription

  public val projects_subtitles_shifter_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_subtitles_shifter_description ?: baseLocale.projects_subtitles_shifter_description

  public val projects_youtube_downloader_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_youtube_downloader_shortDescription ?: baseLocale.projects_youtube_downloader_shortDescription

  public val projects_youtube_downloader_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_youtube_downloader_description ?: baseLocale.projects_youtube_downloader_description

  public val projects_tic_tac_toe_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_tic_tac_toe_shortDescription ?: baseLocale.projects_tic_tac_toe_shortDescription

  public val projects_tic_tac_toe_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_tic_tac_toe_description ?: baseLocale.projects_tic_tac_toe_description

  public val projects_crypto_tracker_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_crypto_tracker_shortDescription ?: baseLocale.projects_crypto_tracker_shortDescription

  public val projects_crypto_tracker_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_crypto_tracker_description ?: baseLocale.projects_crypto_tracker_description

  public val projects_tutor_website_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_tutor_website_shortDescription ?: baseLocale.projects_tutor_website_shortDescription

  public val projects_tutor_website_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_tutor_website_description ?: baseLocale.projects_tutor_website_description

  public val projects_mobile_remote_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_mobile_remote_shortDescription ?: baseLocale.projects_mobile_remote_shortDescription

  public val projects_mobile_remote_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_mobile_remote_description ?: baseLocale.projects_mobile_remote_description

  public val projects_mobile_remote_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_mobile_remote_technicalDescription ?: baseLocale.projects_mobile_remote_technicalDescription

  public val projects_todo_list_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_todo_list_shortDescription ?: baseLocale.projects_todo_list_shortDescription

  public val projects_todo_list_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_todo_list_description ?: baseLocale.projects_todo_list_description

  public val projects_screenshot_processor_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_screenshot_processor_shortDescription ?: baseLocale.projects_screenshot_processor_shortDescription

  public val projects_screenshot_processor_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_screenshot_processor_description ?: baseLocale.projects_screenshot_processor_description

  public val projects_website_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_website_shortDescription ?: baseLocale.projects_website_shortDescription

  public val projects_website_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_website_description ?: baseLocale.projects_website_description

  public val projects_days_counter_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_days_counter_shortDescription ?: baseLocale.projects_days_counter_shortDescription

  public val projects_days_counter_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_days_counter_description ?: baseLocale.projects_days_counter_description

  public val projects_typing_speed_tester_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_typing_speed_tester_shortDescription ?: baseLocale.projects_typing_speed_tester_shortDescription

  public val projects_typing_speed_tester_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_typing_speed_tester_description ?: baseLocale.projects_typing_speed_tester_description

  public val projects_typing_speed_tester_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_typing_speed_tester_technicalDescription ?: baseLocale.projects_typing_speed_tester_technicalDescription

  public val projects_tic_tac_toe_kotlin_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_tic_tac_toe_kotlin_shortDescription ?: baseLocale.projects_tic_tac_toe_kotlin_shortDescription

  public val projects_tic_tac_toe_kotlin_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_tic_tac_toe_kotlin_description ?: baseLocale.projects_tic_tac_toe_kotlin_description

  public val projects_math_tools_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_math_tools_shortDescription ?: baseLocale.projects_math_tools_shortDescription

  public val projects_math_tools_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_math_tools_description ?: baseLocale.projects_math_tools_description

  public val projects_function_solver_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_function_solver_shortDescription ?: baseLocale.projects_function_solver_shortDescription

  public val projects_function_solver_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_function_solver_description ?: baseLocale.projects_function_solver_description

  public val projects_function_solver_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_function_solver_technicalDescription ?: baseLocale.projects_function_solver_technicalDescription

  public val projects_calico_companion_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_calico_companion_shortDescription ?: baseLocale.projects_calico_companion_shortDescription

  public val projects_calico_companion_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_calico_companion_description ?: baseLocale.projects_calico_companion_description

  public val projects_matura_tasks_hub_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_matura_tasks_hub_shortDescription ?: baseLocale.projects_matura_tasks_hub_shortDescription

  public val projects_matura_tasks_hub_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_matura_tasks_hub_description ?: baseLocale.projects_matura_tasks_hub_description

  public val projects_matura_tasks_hub_technicalDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_matura_tasks_hub_technicalDescription ?: baseLocale.projects_matura_tasks_hub_technicalDescription

  public val projects_youtube_uploader_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_youtube_uploader_shortDescription ?: baseLocale.projects_youtube_uploader_shortDescription

  public val projects_youtube_uploader_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_youtube_uploader_description ?: baseLocale.projects_youtube_uploader_description

  public val projects_video_processor_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_video_processor_shortDescription ?: baseLocale.projects_video_processor_shortDescription

  public val projects_video_processor_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_video_processor_description ?: baseLocale.projects_video_processor_description

  public val projects_connect_four_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_connect_four_shortDescription ?: baseLocale.projects_connect_four_shortDescription

  public val projects_connect_four_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_connect_four_description ?: baseLocale.projects_connect_four_description

  public val projects_daymath_image_viewer_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_daymath_image_viewer_shortDescription ?: baseLocale.projects_daymath_image_viewer_shortDescription

  public val projects_daymath_image_viewer_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_daymath_image_viewer_description ?: baseLocale.projects_daymath_image_viewer_description

  public val projects_tutoring_work_sheet_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_tutoring_work_sheet_shortDescription ?: baseLocale.projects_tutoring_work_sheet_shortDescription

  public val projects_tutoring_work_sheet_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_tutoring_work_sheet_description ?: baseLocale.projects_tutoring_work_sheet_description

  public val projects_coroutines_learning_shortDescription: String
    get() = locales[getCurrentLanguageCode()]?.projects_coroutines_learning_shortDescription ?: baseLocale.projects_coroutines_learning_shortDescription

  public val projects_coroutines_learning_description: String
    get() = locales[getCurrentLanguageCode()]?.projects_coroutines_learning_description ?: baseLocale.projects_coroutines_learning_description

  public val experience_title: String
    get() = locales[getCurrentLanguageCode()]?.experience_title ?: baseLocale.experience_title

  public val experience_subtitle: String
    get() = locales[getCurrentLanguageCode()]?.experience_subtitle ?: baseLocale.experience_subtitle

  public val experience_tutor_title: String
    get() = locales[getCurrentLanguageCode()]?.experience_tutor_title ?: baseLocale.experience_tutor_title

  public val experience_tutor_responsibility_1: String
    get() = locales[getCurrentLanguageCode()]?.experience_tutor_responsibility_1 ?: baseLocale.experience_tutor_responsibility_1

  public val experience_tutor_responsibility_2: String
    get() = locales[getCurrentLanguageCode()]?.experience_tutor_responsibility_2 ?: baseLocale.experience_tutor_responsibility_2

  public val experience_tutor_responsibility_3: String
    get() = locales[getCurrentLanguageCode()]?.experience_tutor_responsibility_3 ?: baseLocale.experience_tutor_responsibility_3

  public val experience_app_developer_title: String
    get() = locales[getCurrentLanguageCode()]?.experience_app_developer_title ?: baseLocale.experience_app_developer_title

  public val experience_app_developer_responsibility_1: String
    get() = locales[getCurrentLanguageCode()]?.experience_app_developer_responsibility_1 ?: baseLocale.experience_app_developer_responsibility_1

  public val experience_app_developer_responsibility_2: String
    get() = locales[getCurrentLanguageCode()]?.experience_app_developer_responsibility_2 ?: baseLocale.experience_app_developer_responsibility_2

  public val students_taught: String
    get() = locales[getCurrentLanguageCode()]?.students_taught ?: baseLocale.students_taught

  public val rating: String
    get() = locales[getCurrentLanguageCode()]?.rating ?: baseLocale.rating

  public val reviews: String
    get() = locales[getCurrentLanguageCode()]?.reviews ?: baseLocale.reviews

  public val apps_published: String
    get() = locales[getCurrentLanguageCode()]?.apps_published ?: baseLocale.apps_published

  public val total_downloads: String
    get() = locales[getCurrentLanguageCode()]?.total_downloads ?: baseLocale.total_downloads

  public val home: String
    get() = locales[getCurrentLanguageCode()]?.home ?: baseLocale.home

  public val self_employed: String
    get() = locales[getCurrentLanguageCode()]?.self_employed ?: baseLocale.self_employed

  public val commercial: String
    get() = locales[getCurrentLanguageCode()]?.commercial ?: baseLocale.commercial

  public val primary_technologies: String
    get() = locales[getCurrentLanguageCode()]?.primary_technologies ?: baseLocale.primary_technologies

  public val education_title: String
    get() = locales[getCurrentLanguageCode()]?.education_title ?: baseLocale.education_title

  public val education_subtitle: String
    get() = locales[getCurrentLanguageCode()]?.education_subtitle ?: baseLocale.education_subtitle

  public val education_uj_degree: String
    get() = locales[getCurrentLanguageCode()]?.education_uj_degree ?: baseLocale.education_uj_degree

  public val education_uj_organization: String
    get() = locales[getCurrentLanguageCode()]?.education_uj_organization ?: baseLocale.education_uj_organization

  public val education_zsz_degree: String
    get() = locales[getCurrentLanguageCode()]?.education_zsz_degree ?: baseLocale.education_zsz_degree

  public val education_zsz_organization: String
    get() = locales[getCurrentLanguageCode()]?.education_zsz_organization ?: baseLocale.education_zsz_organization

  public val Poland: String
    get() = locales[getCurrentLanguageCode()]?.Poland ?: baseLocale.Poland

  public val Algebra: String
    get() = locales[getCurrentLanguageCode()]?.Algebra ?: baseLocale.Algebra

  public val ComputerOrganizationAndArchitecture: String
    get() = locales[getCurrentLanguageCode()]?.ComputerOrganizationAndArchitecture ?: baseLocale.ComputerOrganizationAndArchitecture

  public val Programming: String
    get() = locales[getCurrentLanguageCode()]?.Programming ?: baseLocale.Programming

  public val LogicAndSetTheory: String
    get() = locales[getCurrentLanguageCode()]?.LogicAndSetTheory ?: baseLocale.LogicAndSetTheory

  public val MathematicalAnalysis: String
    get() = locales[getCurrentLanguageCode()]?.MathematicalAnalysis ?: baseLocale.MathematicalAnalysis

  public val ProgrammingMethods: String
    get() = locales[getCurrentLanguageCode()]?.ProgrammingMethods ?: baseLocale.ProgrammingMethods

  public val OperatingSystems: String
    get() = locales[getCurrentLanguageCode()]?.OperatingSystems ?: baseLocale.OperatingSystems

  public val AlgorithmsAndDataStructures: String
    get() = locales[getCurrentLanguageCode()]?.AlgorithmsAndDataStructures ?: baseLocale.AlgorithmsAndDataStructures

  public val DiscreteMathematics: String
    get() = locales[getCurrentLanguageCode()]?.DiscreteMathematics ?: baseLocale.DiscreteMathematics

  public val Databases: String
    get() = locales[getCurrentLanguageCode()]?.Databases ?: baseLocale.Databases

  public val SoftwareEngineering: String
    get() = locales[getCurrentLanguageCode()]?.SoftwareEngineering ?: baseLocale.SoftwareEngineering

  public val ProbabilityAndStatistics: String
    get() = locales[getCurrentLanguageCode()]?.ProbabilityAndStatistics ?: baseLocale.ProbabilityAndStatistics

  public val ComputerNetworks: String
    get() = locales[getCurrentLanguageCode()]?.ComputerNetworks ?: baseLocale.ComputerNetworks

  public val FormalLanguagesAndAutomata: String
    get() = locales[getCurrentLanguageCode()]?.FormalLanguagesAndAutomata ?: baseLocale.FormalLanguagesAndAutomata

  public val NumericalMethods: String
    get() = locales[getCurrentLanguageCode()]?.NumericalMethods ?: baseLocale.NumericalMethods

  public val FunctionalProgramming: String
    get() = locales[getCurrentLanguageCode()]?.FunctionalProgramming ?: baseLocale.FunctionalProgramming

  public val AndroidProgramming: String
    get() = locales[getCurrentLanguageCode()]?.AndroidProgramming ?: baseLocale.AndroidProgramming

  public val DesignPatterns: String
    get() = locales[getCurrentLanguageCode()]?.DesignPatterns ?: baseLocale.DesignPatterns

  public val CSharpProgramming: String
    get() = locales[getCurrentLanguageCode()]?.CSharpProgramming ?: baseLocale.CSharpProgramming

  public val CognitiveSystems: String
    get() = locales[getCurrentLanguageCode()]?.CognitiveSystems ?: baseLocale.CognitiveSystems

  public val CognitiveScience: String
    get() = locales[getCurrentLanguageCode()]?.CognitiveScience ?: baseLocale.CognitiveScience

  public val WebProgramming: String
    get() = locales[getCurrentLanguageCode()]?.WebProgramming ?: baseLocale.WebProgramming

  public val FundamentalsOfAI: String
    get() = locales[getCurrentLanguageCode()]?.FundamentalsOfAI ?: baseLocale.FundamentalsOfAI

  public val English: String
    get() = locales[getCurrentLanguageCode()]?.English ?: baseLocale.English

  public val Networking: String
    get() = locales[getCurrentLanguageCode()]?.Networking ?: baseLocale.Networking

  public val HardwareMaintenance: String
    get() = locales[getCurrentLanguageCode()]?.HardwareMaintenance ?: baseLocale.HardwareMaintenance

  public val CertificateCCNARoutingAndSwitchingIntroductionToNetworks: String
    get() = locales[getCurrentLanguageCode()]?.CertificateCCNARoutingAndSwitchingIntroductionToNetworks ?: baseLocale.CertificateCCNARoutingAndSwitchingIntroductionToNetworks

  public val CertificatePCAPProgrammingEssentialsInPython: String
    get() = locales[getCurrentLanguageCode()]?.CertificatePCAPProgrammingEssentialsInPython ?: baseLocale.CertificatePCAPProgrammingEssentialsInPython

  public val CertificateNDGLinuxUnhatched: String
    get() = locales[getCurrentLanguageCode()]?.CertificateNDGLinuxUnhatched ?: baseLocale.CertificateNDGLinuxUnhatched

  public val CertificateIntroductionToCybersecurity: String
    get() = locales[getCurrentLanguageCode()]?.CertificateIntroductionToCybersecurity ?: baseLocale.CertificateIntroductionToCybersecurity

  public val CertificateCybersecurityEssentials: String
    get() = locales[getCurrentLanguageCode()]?.CertificateCybersecurityEssentials ?: baseLocale.CertificateCybersecurityEssentials

  public val CertificateBeYourOwnBoss: String
    get() = locales[getCurrentLanguageCode()]?.CertificateBeYourOwnBoss ?: baseLocale.CertificateBeYourOwnBoss

  public val CertificateGetConnected: String
    get() = locales[getCurrentLanguageCode()]?.CertificateGetConnected ?: baseLocale.CertificateGetConnected

  public val CertificateIntroductionToTheInternetOfEverything: String
    get() = locales[getCurrentLanguageCode()]?.CertificateIntroductionToTheInternetOfEverything ?: baseLocale.CertificateIntroductionToTheInternetOfEverything

  public val Certificate3dsMaxAnimation: String
    get() = locales[getCurrentLanguageCode()]?.Certificate3dsMaxAnimation ?: baseLocale.Certificate3dsMaxAnimation

  public val Certificate3dsMaxVisualisation: String
    get() = locales[getCurrentLanguageCode()]?.Certificate3dsMaxVisualisation ?: baseLocale.Certificate3dsMaxVisualisation

  public val Certificate3dsMaxModeling: String
    get() = locales[getCurrentLanguageCode()]?.Certificate3dsMaxModeling ?: baseLocale.Certificate3dsMaxModeling

  public val CertificateEUCodeWeek: String
    get() = locales[getCurrentLanguageCode()]?.CertificateEUCodeWeek ?: baseLocale.CertificateEUCodeWeek

  public val CertificateCPAProgrammingEssentialsInCPlusPlus: String
    get() = locales[getCurrentLanguageCode()]?.CertificateCPAProgrammingEssentialsInCPlusPlus ?: baseLocale.CertificateCPAProgrammingEssentialsInCPlusPlus

  public val programming_and_software_engineering: String
    get() = locales[getCurrentLanguageCode()]?.programming_and_software_engineering ?: baseLocale.programming_and_software_engineering

  public val mathematics: String
    get() = locales[getCurrentLanguageCode()]?.mathematics ?: baseLocale.mathematics

  public val systems_and_computer_technology: String
    get() = locales[getCurrentLanguageCode()]?.systems_and_computer_technology ?: baseLocale.systems_and_computer_technology

  public val ai_and_cognitive_science: String
    get() = locales[getCurrentLanguageCode()]?.ai_and_cognitive_science ?: baseLocale.ai_and_cognitive_science

  public val courses: String
    get() = locales[getCurrentLanguageCode()]?.courses ?: baseLocale.courses

  public val professional_certificates: String
    get() = locales[getCurrentLanguageCode()]?.professional_certificates ?: baseLocale.professional_certificates

  public val achievements_title: String
    get() = locales[getCurrentLanguageCode()]?.achievements_title ?: baseLocale.achievements_title

  public val achievements_subtitle: String
    get() = locales[getCurrentLanguageCode()]?.achievements_subtitle ?: baseLocale.achievements_subtitle

  public val programming_competitions: String
    get() = locales[getCurrentLanguageCode()]?.programming_competitions ?: baseLocale.programming_competitions

  public val math_competitions: String
    get() = locales[getCurrentLanguageCode()]?.math_competitions ?: baseLocale.math_competitions

  public val scholarships: String
    get() = locales[getCurrentLanguageCode()]?.scholarships ?: baseLocale.scholarships

  public val other_achievements: String
    get() = locales[getCurrentLanguageCode()]?.other_achievements ?: baseLocale.other_achievements

  public val FirstPlaceInTheIndependenceDictationContest: String
    get() = locales[getCurrentLanguageCode()]?.FirstPlaceInTheIndependenceDictationContest ?: baseLocale.FirstPlaceInTheIndependenceDictationContest

  public val PrzeworskCountyScholarship: String
    get() = locales[getCurrentLanguageCode()]?.PrzeworskCountyScholarship ?: baseLocale.PrzeworskCountyScholarship

  public val FirstPlaceInTheExpertGroupAtThePix2019ContestNationalSchoolProgrammingChampionship:
      String
    get() = locales[getCurrentLanguageCode()]?.FirstPlaceInTheExpertGroupAtThePix2019ContestNationalSchoolProgrammingChampionship ?: baseLocale.FirstPlaceInTheExpertGroupAtThePix2019ContestNationalSchoolProgrammingChampionship

  public val QualificationToTheSemiFinalsOfThePolishEditionOfTheInternationalPixProgrammingChallenge:
      String
    get() = locales[getCurrentLanguageCode()]?.QualificationToTheSemiFinalsOfThePolishEditionOfTheInternationalPixProgrammingChallenge ?: baseLocale.QualificationToTheSemiFinalsOfThePolishEditionOfTheInternationalPixProgrammingChallenge

  public val HonorableMentionInTheNationalHistoryContestKrag: String
    get() = locales[getCurrentLanguageCode()]?.HonorableMentionInTheNationalHistoryContestKrag ?: baseLocale.HonorableMentionInTheNationalHistoryContestKrag

  public val SecondPlaceInThe24thProfJanMarszalMathematicsContestForMiddleSchools: String
    get() = locales[getCurrentLanguageCode()]?.SecondPlaceInThe24thProfJanMarszalMathematicsContestForMiddleSchools ?: baseLocale.SecondPlaceInThe24thProfJanMarszalMathematicsContestForMiddleSchools

  public val FirstPlaceInTheSchoolProgrammingContest: String
    get() = locales[getCurrentLanguageCode()]?.FirstPlaceInTheSchoolProgrammingContest ?: baseLocale.FirstPlaceInTheSchoolProgrammingContest

  public val HonorableMentionInThe15thDistrictMathContestProcent: String
    get() = locales[getCurrentLanguageCode()]?.HonorableMentionInThe15thDistrictMathContestProcent ?: baseLocale.HonorableMentionInThe15thDistrictMathContestProcent

  public val FirstPlaceInThe14thDistrictMathContestForSecondYearMiddleSchoolStudents: String
    get() = locales[getCurrentLanguageCode()]?.FirstPlaceInThe14thDistrictMathContestForSecondYearMiddleSchoolStudents ?: baseLocale.FirstPlaceInThe14thDistrictMathContestForSecondYearMiddleSchoolStudents

  public val SecondPlaceInTheSchoolEnglishContest: String
    get() = locales[getCurrentLanguageCode()]?.SecondPlaceInTheSchoolEnglishContest ?: baseLocale.SecondPlaceInTheSchoolEnglishContest

  public val HonorableMentionInTheInternationalMathContestKangurMatematyczny: String
    get() = locales[getCurrentLanguageCode()]?.HonorableMentionInTheInternationalMathContestKangurMatematyczny ?: baseLocale.HonorableMentionInTheInternationalMathContestKangurMatematyczny

  public val first_place: String
    get() = locales[getCurrentLanguageCode()]?.first_place ?: baseLocale.first_place

  public val school: String
    get() = locales[getCurrentLanguageCode()]?.school ?: baseLocale.school

  public val regional: String
    get() = locales[getCurrentLanguageCode()]?.regional ?: baseLocale.regional

  public val national: String
    get() = locales[getCurrentLanguageCode()]?.national ?: baseLocale.national

  public val international: String
    get() = locales[getCurrentLanguageCode()]?.international ?: baseLocale.international

  public val district: String
    get() = locales[getCurrentLanguageCode()]?.district ?: baseLocale.district

  public val social_media_title: String
    get() = locales[getCurrentLanguageCode()]?.social_media_title ?: baseLocale.social_media_title

  public val social_media_subtitle: String
    get() = locales[getCurrentLanguageCode()]?.social_media_subtitle ?: baseLocale.social_media_subtitle

  public val january: String
    get() = locales[getCurrentLanguageCode()]?.january ?: baseLocale.january

  public val february: String
    get() = locales[getCurrentLanguageCode()]?.february ?: baseLocale.february

  public val march: String
    get() = locales[getCurrentLanguageCode()]?.march ?: baseLocale.march

  public val april: String
    get() = locales[getCurrentLanguageCode()]?.april ?: baseLocale.april

  public val may: String
    get() = locales[getCurrentLanguageCode()]?.may ?: baseLocale.may

  public val june: String
    get() = locales[getCurrentLanguageCode()]?.june ?: baseLocale.june

  public val july: String
    get() = locales[getCurrentLanguageCode()]?.july ?: baseLocale.july

  public val august: String
    get() = locales[getCurrentLanguageCode()]?.august ?: baseLocale.august

  public val september: String
    get() = locales[getCurrentLanguageCode()]?.september ?: baseLocale.september

  public val october: String
    get() = locales[getCurrentLanguageCode()]?.october ?: baseLocale.october

  public val november: String
    get() = locales[getCurrentLanguageCode()]?.november ?: baseLocale.november

  public val december: String
    get() = locales[getCurrentLanguageCode()]?.december ?: baseLocale.december

  public val now: String
    get() = locales[getCurrentLanguageCode()]?.now ?: baseLocale.now

  public val n_apps_published: VoidPluralString
    get() = locales[getCurrentLanguageCode()]?.n_apps_published ?: baseLocale.n_apps_published

  public val n_courses: LibresFormatNCourses
    get() = locales[getCurrentLanguageCode()]?.n_courses ?: baseLocale.n_courses

  public val n_certificates: LibresFormatNCertificates
    get() = locales[getCurrentLanguageCode()]?.n_certificates ?: baseLocale.n_certificates

  public val n_achievements: LibresFormatNAchievements
    get() = locales[getCurrentLanguageCode()]?.n_achievements ?: baseLocale.n_achievements

  public val n_years: LibresFormatNYears
    get() = locales[getCurrentLanguageCode()]?.n_years ?: baseLocale.n_years
}
